import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'file-with-speaker';

const originalDimensions = {
    width: 24,
    height: 24,
};

// A custom icon created by layering stockholm-icon-set/Media/Volume-full.svg over the top of
// stockholm-icon-set/Files/File-minus.svg

export const IconFileWithSpeaker = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>File with Speaker Icon</title>
            <g fillRule="evenodd" fill="none">
                <path d="M0 24V0h24v24z" />
                <path
                    opacity=".3"
                    fillRule="nonzero"
                    fill={fill}
                    d="M5.857 2h7.88a1.5 1.5 0 01.968.355l4.764 4.029A1.5 1.5 0 0120 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z"
                />
            </g>
            <path
                d="M14.701 15.219a.45.45 0 01-.438-.784 1.946 1.946 0 00.012-3.394.45.45 0 01.445-.78 2.844 2.844 0 01-.019 4.958zm.284 2.24a.45.45 0 01-.39-.81 4.342 4.342 0 00.04-7.81.45.45 0 11.398-.806 5.24 5.24 0 01-.049 9.427z"
                opacity=".3"
                fill={fill}
            />
            <path
                d="M9.122 15.13l-2.032-.406a1.198 1.198 0 01-.963-1.175v-1.63c0-.57.403-1.062.963-1.174l2.032-.407 1.972-1.972a.599.599 0 011.022.424v7.889a.599.599 0 01-1.022.423z"
                fill={fill}
            />
        </svg>
    );
};
